import React from 'react';

export const Button = ({
  type = "button",
  label = 'Button',
  onClick = null,
  ...props,
}) => (
  <input type={type} value={label} onClick={onClick} className="noprint" {...props} />
);
